// Small pieces of the Knowledge base screens: the type square, the folder card, where a folder sits.
import { Link } from 'react-router-dom';
import { shownSpaceColor } from '@dpw/shared';
import type { Folder, SpaceColor } from '@dpw/shared';
import { useSpaces } from '../lib/queries';
import { IconFolder } from '../ui/icons';
import { KIND, kindOf, scopeDot, updatedText } from './model';

export const TypeTag = ({ name, lg }: { name: string; lg?: boolean }) => {
  const k = kindOf(name);
  return <span className={`ty2${lg ? ' lg' : ''} ${k}`} aria-hidden="true">{KIND[k][0]}</span>;
};

/** Space colours by id, for the scope dots. */
export function useSpaceColors(): Map<string, SpaceColor> {
  const { data } = useSpaces();
  return new Map((data ?? []).map(s => [s.id, shownSpaceColor(s.color)]));
}

export const Scope = ({ f, colors }: { f: Pick<Folder, 'spaceId' | 'spaceName'>; colors: Map<string, SpaceColor> }) => (
  <span className="scp"><i style={{ background: scopeDot(f.spaceId ? colors.get(f.spaceId) ?? 'grn' : null) }} />{f.spaceName ?? 'Team-wide'}</span>
);

export const filesText = (n: number) => `${n} ${n === 1 ? 'file' : 'files'}`;

/** A folder on the home grid and the space's Knowledge tab. */
export function FolderCard({ f, colors }: { f: Folder; colors: Map<string, SpaceColor> }) {
  return (
    <Link className="fcard" to={`/folders/${f.id}`} data-folder={f.name}>
      <span className="fct"><span className="fic"><IconFolder /></span><Scope f={f} colors={colors} /></span>
      <h3>{f.name}</h3>
      <p>{f.description || 'No description yet. Add one so the assistant knows when to open this folder.'}</p>
      <span className="fcf"><b>{filesText(f.fileCount)}</b><span>· Updated {updatedText(f.lastChange.at, f.lastChange.by)}</span></span>
    </Link>
  );
}
